// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
{
    var define_node = require('../../../../util/require_node.js')
        .define(module, '..');
    define = function(_deps, fn){
        return define_node(['lodash4', 'classnames'], fn); };
}
else
    define = self.define;
// avoid heavy dependencies on this file
// also make sure there's no other util file where the func would fit better
define(['lodash4', 'classnames', '/www/lum/pub/config.js', '/util/escape.js',
    '/util/setdb.js'],
       (_, classnames, config={}, zescape, setdb)=>
{
const {url2md5} = config;
const E = {};

E.cp_url = (path, qs={}, opt={})=>{
    let customer = opt.customer || setdb.get('head.customer.current');
    let query = Object.assign({}, qs,
        customer && {id: customer.id});
    return zescape.uri('/cp'+path, query);
};
E.img_url = name=>url2md5('/www/lum/pub/img/'+name);
E.css_url = name=>url2md5('/www/lum/pub/css/'+name);
E.fmt_num = n=>n&&n.toLocaleString({useGrouping: true})||n;
E.fmt_round = n=>isNaN(n)? '' : E.fmt_num(Math.round(n));
E.fmt_currency = n=>isNaN(n) ? '' : (Math.sign(n)==-1 ? '-' : '')+'$'
    +E.fmt_round(Math.abs(n));
E.fmt_percent = (n, p=2)=>isNaN(n) ? '' : E.fmt_num((n*100).toFixed(p))+'%';
E.get_classname = (base = '', classes = '', optionals = [], obj = {})=>{
    if (!_.isArray(optionals))
        optionals = [optionals];
    return classnames(`${base} ${classes}`, optionals.reduce((acc, o)=>
        Object.assign(acc, {[`${base}_${o}`]: !!obj[o]}), {}));
};
E.get_fractional = v=>v.toFixed(3).replace(/0$/, '').split('.')[1];
E.order_by_key = (order, data)=>(order||[]).length ?
    order.reduce((d, o)=>Object.assign(d, {[o]: data[o]}), {}) : data;
E.base64_to_blob = (base64_data, content_type='', slice_size=512)=>{
    let byte_characters = window.atob(base64_data);
    let byte_arrays = [];
    for (let offset = 0; offset < byte_characters.length; offset += slice_size)
    {
        let slice = byte_characters.slice(offset, offset + slice_size);
        let byte_numbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++)
            byte_numbers[i] = slice.charCodeAt(i);
        let byteArray = new Uint8Array(byte_numbers);

        byte_arrays.push(byteArray);
    }
    let blob = new Blob(byte_arrays, {type: content_type});
    return blob;
};

// Polyfills
if (!is_node)
{
    if (!Object.entries)
    {
        Object.entries = function(obj){
            const own_props = Object.keys(obj);
            let i = own_props.length;
            const res_array = new Array(i);
            while (i--)
                res_array[i] = [own_props[i], obj[own_props[i]]];
            return res_array;
        };
    }
    if (!Object.fromEntries)
    {
        Object.fromEntries = function(entries){
            const res = {};
            for (let i = 0; i < entries.length; i++)
                res[entries[i][0]] = entries[i][1];
            return res;
        };
    }
}

return E; }); // eslint-disable-line
